import { api } from "./api";

export const fightList = async (params: any): Promise<any> => {
  const { data } = await api.get("/store/fights", { params });
  return data;
};

export const fightById = async (id: number): Promise<any> => {
  const { data } = await api.get(`/store/fights/${id}`);
  return data;
};
